import defaultApi from '@/utils/request';

export default {
  // 加載列表

  Get_S90Division(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90Division',
      params,
    });
  },
  Get_S90Degree(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90Degree',
      params,
    });
  },
  Get_S90Degree_By_Dvs(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90Degree_By_Dvs',
      params,
    });
  },
  Get_S90Unit_By_Dgr(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90Unit_By_Dgr',
      params,
    });
  },
  Get_S90Unit_By_Adm(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90Unit_By_Adm',
      params,
    });
  },
  Get_S90Unit_By_Edu(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90Unit_By_Edu',
      params,
    });
  },
  Get_S90Unit_Level(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90Unit_Level',
      params,
    });
  },
  Get_S90Unit_Level1(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90Unit_Level1',
      params,
    });
  },
  Get_S90Unit_Level2(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90Unit_Level2',
      params,
    });
  },
  Get_S90Class_By_Dgr_Unt(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90Class_By_Dgr_Unt',
      params,
    });
  },
  Get_S90Class_By_Dgr_Unt_Cond(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90Class_By_Dgr_Unt_Cond',
      params,
    });
  },
  Get_S90Building(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90Building',
      params,
    });
  },
  Get_S90Room_By_Bldid(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90Room_By_Bldid',
      params,
    });
  },
  Get_S90Bank(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90Bank',
      params,
    });
  },
  Get_S90BankS1c_By_Bankid(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90BankS1c_By_Bankid',
      params,
    });
  },
  Get_S90City(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90City',
      params,
    });
  },
  Get_S90CityZip_By_Cityid(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90CityZip_By_Cityid',
      params,
    });
  },
  Get_S90Yms_By_All_Sort_A(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90Yms_By_All_Sort_A',
      params,
    });
  },
  Get_S90Yms_By_All_Sort_D(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90Yms_By_All_Sort_D',
      params,
    });
  },
  Get_S90College(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_S90College',
      params,
    });
  },
  Get_SignOfAgent(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_SignOfAgent',
      params,
    });
  },
  YmsListSelector(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/YmsListSelector',
      params,
    });
  },
  /* -------------------- 銀行名稱查詢 Start -------------------- */
  BankSearchViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/BankSearchViewLoad',
      params,
    });
  },
  BankTypeSelectorLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/BankTypeSelectorLoad',
      params,
    });
  },
  BankNameSelectorLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/BankNameSelectorLoad',
      params,
    });
  },
  BankCitySelectorLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/BankCitySelectorLoad',
      params,
    });
  },
  BankOfficeSelectorLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/BankOfficeSelectorLoad',
      params,
    });
  },
  GetBankSearchData(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/GetBankSearchData',
      params,
    });
  },
  /* -------------------- 銀行名稱查詢 End -------------------- */
  Get_FlowEngineProgressViewData(params) {
    return defaultApi({
      method: 'get',
      url: 'Common/Get_FlowEngineProgressViewData',
      params,
    });
  },
};
